export class BoipaNotificationDto {
  country?: string;
  amount?: string;
  acquirerTxId?: string;
  txId?: string;
  /**
   * This "block" has card expiration date, masked card number etc.
   * Receive this in the merchantNotificationUrl response.
   */
  paymentSolutionDetails?: string;
  acquirer?: string;
  acquirerAmount?: string;
  myriadFlowId?: string;
  merchantId?: string;
  brandId?: string;
  merchantTxId?: string;
  customerId?: string;
  acquirerCurrency?: string;
  action?: string;
  paymentSolutionId?: string;
  currency?: string;
  /**
   * Card Tokenization result.
   * Used as `specinCreditCardToken`
   */
  pan?: string;
  /**
   * Attached to session token, will be returned by BOIPA API.
   */
  freeText?: string;
  status?: string;
  originalTxId?: string;
  originalMerchantTxId?: string;
}

export class BoipaPaymentSolutionDetails {
  expiryDate?: string;
  authCode?: string;
  maskedPan?: string;
  nameOnCard?: string;
  cardType?: string;
}

// sample success
// {
//     country: 'IE',
//     amount: '6.00',
//     acquirerTxId: 'FC4B92651DF1407AAEA48E6CFF822616',
//     txId: '11894890',
//     paymentSolutionDetails: '{expiryDate=03/2024, authCode=3E7VUK, maskedPan=411111******1111, nameOnCard=Bogdan Enache, cardType=VISA CREDIT}',
//     acquirer: 'EVO899986',
//     acquirerAmount: '6.00',
//     myriadFlowId: 'api-eaPFMR',
//     merchantId: '899986',
//     brandId: '899986000',
//     merchantTxId: '283',
//     customerId: '44',
//     acquirerCurrency: 'EUR',
//     action: 'AUTH',
//     paymentSolutionId: '500',
//     currency: 'EUR',
//     pan: '6745296604991111',
//     status: 'NOT_SET_FOR_CAPTURE',
//     originalTxId: 'null'
//   }

// sample declined

// {
//     country: 'IE',
//     amount: '6.00',
//     errorMessage: 'Error response from Payment Provider: 3DSecure authentication failed: null',
//     txId: '11894971',
//     paymentSolutionDetails: '{expiryDate=03/2024, maskedPan=411111******1111, nameOnCard=Bogdan Enache, cardType=VISA CREDIT}',
//     acquirer: 'EVO899986',
//     acquirerAmount: '6.00',
//     myriadFlowId: 'api-8e9Ylh',
//     merchantId: '899986',
//     brandId: '899986000',
//     merchantTxId: '284',
//     customerId: '44',
//     acquirerCurrency: 'EUR',
//     action: 'AUTH',
//     paymentSolutionId: '500',
//     currency: 'EUR',
//     pan: '6745296604991111',
//     status: 'DECLINED',
//     originalTxId: 'null'
//   }
